export const getHttpRequests = (storeState) => storeState.httpRequests;
